import styled from 'styled-components';
import RefundBreakSvg from '../../assets/mytrips/refund-breakup.svg';

const RefundBreakIcon = styled(RefundBreakSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1.9rem'};
  height: ${props => props.height || '1.7rem'};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default RefundBreakSvg;
